module.exports = __webpack_public_path__ + "media/images/top/budget_table/kojin_pc_over10000-2507b6108a9012e9cbd4bfdbfaa9c262.png";